
  const company = {
    path: "/maps/manage",
    name: "ManageMaps",
    component: () => import(/* webpackChunkName: "maps-manage" */ "@/components/map/ManageMaps.vue"),
    meta: { authorize: ['Administrator', 'Manager'], requiresAuth: true }
  };

export default company;
    